import React from "react"

/**
 * 未定義部分のページにアクセスされた場合に表示する部分
 */
export default function Undefined() {
  return (
    <div>
      <h1>未定義ページです</h1>
    </div>
  )
}